import { render, staticRenderFns } from "./BronchopneumoniaEconomicLossReport.vue?vue&type=template&id=17cd5c4d&scoped=true&"
import script from "./BronchopneumoniaEconomicLossReport.vue?vue&type=script&lang=ts&"
export * from "./BronchopneumoniaEconomicLossReport.vue?vue&type=script&lang=ts&"
import style0 from "./BronchopneumoniaEconomicLossReport.vue?vue&type=style&index=0&id=17cd5c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cd5c4d",
  null
  
)

export default component.exports